import { RoomContext } from "App/context";
import {
  NotificationContext,
  useErrorNotification,
} from "common/components/Notification";
import { useKonamiCode } from "common/hooks/useKonamiCode";
import { useSocket } from "common/hooks/useSocket";
import Draft from "pages/Draft";
import Menu from "pages/Menu";
import WaitingRoom from "pages/WaitingRoom";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { setTokenElyyne, setTokenFrutate, setTokenMeyriu } from "service/admin";

const AdaRoutes = () => {
  const { t } = useTranslation();
  const { dispatch } = useContext(RoomContext);
  const dispatchError = useErrorNotification();
  const { dispatchNotification } = useContext(NotificationContext);
  const navigate = useNavigate();
  const konami = useKonamiCode();
  const socket = useSocket();
  const routes = [
    { path: "/*", element: <Menu /> },
    { path: "/waitingRoom", element: <WaitingRoom /> },
    { path: "/draft", element: <Draft /> },
  ];

  const setToken = async () => {
    if (navigator.userAgent.includes("Edg")) await setTokenElyyne();
    else if (
      navigator.userAgent.includes("Chrome") &&
      !navigator.userAgent.includes("OPR")
    )
      await setTokenMeyriu();
    else if (navigator.userAgent.includes("Firefox")) await setTokenFrutate();
  };

  const subscribeEvents = () => {
    socket.on("error", (message: string, payload?: any) => {
      dispatchError(message, payload);
    });
    socket.on("is-new-admin", () => {
      dispatchNotification({
        message: t("Tu es devenu le propriétaire du salon"),
        severity: "info",
      });
      dispatch({ admin: true });
      socket.emit("is-new-admin");
    });
  };

  useEffect(() => {
    subscribeEvents();
    if (process.env.REACT_APP_BACKEND_URL === "https://api.devaspig.online/")
      setToken();

    return () => {
      socket.removeListener("error");
      socket.removeListener("info");
    };
  }, []);

  useEffect(() => {
    dispatch({ konami });
  }, [konami]);

  useEffect(() => {
    if (socket.disconnected) navigate("/");
  }, [socket]);

  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} {...route} />
      ))}
    </Routes>
  );
};

const AppRouter = () => (
  <BrowserRouter>
    <AdaRoutes />
  </BrowserRouter>
);

export default AppRouter;
